import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../BaseUrlConfigration/ApiConfig";
import { constructQueryString } from "../../Util/HelperFunction";

export const workerListAction = createAsyncThunk(
  "worker/list",
  async (reqBody, thunkAPI) => {
    try {
      const query = constructQueryString(reqBody);
      const response = await Api.get(`/worker/list?${query}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const workerCsvListAction = createAsyncThunk(
  "worker/workerCsvlist",
  async (reqBody, thunkAPI) => {
    try {
      const query = constructQueryString(reqBody);
      const response = await Api.get(`/worker/csv/download?${query}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const workerCollectionListAction = createAsyncThunk(
  "worker/collection",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.get(`/worker/collection?id=${reqBody.id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const workerEditAction = createAsyncThunk(
  "worker/edit",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.put("worker/edit", reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const workerCreateAction = createAsyncThunk(
  "worker/create",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.post("worker/create", reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const weelklyLoginworkerAction = createAsyncThunk(
  "worker/workerLogin",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.get(
        `/worker/active-hours?id=${reqBody?.id}&startOfWeek=${reqBody?.date?.startOfWeek}&endOfWeek=${reqBody?.date?.endOfWeek}`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const workerClassListAction = createAsyncThunk(
  "worker/class",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.get(`/worker/class?id=${reqBody.id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const workerDeleteAction = createAsyncThunk(
  "worker/delete",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.delete(`/worker/delete?id=${reqBody.id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const workerSuspendAction = createAsyncThunk(
  "worker/suspend",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.post(`/worker/suspend`, reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const workerdetailsAction = createAsyncThunk(
  "worker/details",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.get(`/worker/details?id=${reqBody.id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const workerResetPassAction = createAsyncThunk(
  "worker/reset-password",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.put(`worker/reset-password`, reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const workerTimelineAction = createAsyncThunk(
  "worker/timeline",
  async (reqBody, thunkAPI) => {
    try {
      const id = reqBody?.workerId || reqBody?.id;
      const response = await Api.get(
        `/worker-timeline?id=${id}`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);
